<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('housing_reservations')"
                        :isFilter="false"
                        :isColumns="false"
                />
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile
                    :title="$t('housing_reservations')"
                    :isFilter="false"
                    :isColumns="false"
                />
            </template>
            <datatable-filter v-show="datatable.filterStatus" @filter="filter" @filterClear="filterClear"
                              :exportExcel="checkPermission('housingreservation_excelexport')" @exportExcel="exportExcel" >
                <b-row>
                    <b-col cols="12" md="6">
                        <b-form-group :label="$t('first_name')">
                            <b-form-input
                                v-model="datatable.queryParams.filter.filter_by_name"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6">
                        <b-form-group :label="$t('last_name')">
                            <b-form-input
                                v-model="datatable.queryParams.filter.filter_by_surname"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6">
                        <b-form-group :label="$t('student_id')">
                            <b-form-input size="sm" v-model="datatable.queryParams.filter.student_number"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6">
                        <b-form-group :label="$t('email')">
                            <b-form-input type="email"
                                          v-model="datatable.queryParams.filter.email"/>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6">
                        <b-form-group :label="$t('personal_email')">
                            <b-form-input type="email"
                                          v-model="datatable.queryParams.filter.personal_email"/>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6">
                        <b-form-group :label="$t('tenant_type')">
                            <parameter-selectbox
                                code="housing_tenant_types"
                                v-model="datatable.queryParams.filter.tenant_type"
                            ></parameter-selectbox>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6">
                        <b-form-group :label="$t('room_type')">
                            <parameter-selectbox
                                code="housing_room_types"
                                v-model="datatable.queryParams.filter.room_type"
                            ></parameter-selectbox>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6">
                        <b-form-group :label="$t('building')">
                            <HouseBuildingSelectbox
                                v-model="datatable.queryParams.filter.building_id"
                            ></HouseBuildingSelectbox>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6">
                        <b-form-group :label="$t('room')">
                            <HouseRoomSelectbox
                                :housing_building_id="datatable.queryParams.filter.building_id"
                                v-model="datatable.queryParams.filter.room_id"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6">
                        <b-form-group label="Check In Date Between">
                            <v-date-picker v-model="datatable.queryParams.filter.check_in_date"
                                           is-range
                                           :locale="'en'"
                                           :model-config="{type: 'string', mask: 'MM/DD/YYYY'}"
                            >
                                <template v-slot="{ inputValue, inputEvents }">
                                    <div class="border rounded-sm p-1 p-md-3 d-flex align-items-center">
                                        <div class="flex-grow-1">
                                            <b-form-group class="m-0 mr-1">
                                                <input :value="inputValue.start"
                                                       v-on="inputEvents.start"
                                                       :placeholder="$t('start_date')"
                                                       class="form-control"
                                                />
                                            </b-form-group>
                                        </div>
                                        <div class="flex-grow-1">
                                            <b-form-group class="m-0 ml-1">
                                                <input :value="inputValue.end"
                                                       v-on="inputEvents.end"
                                                       :placeholder="$t('end_date')"
                                                       class="form-control"
                                                />
                                            </b-form-group>
                                        </div>
                                    </div>
                                </template>
                            </v-date-picker>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6">
                        <b-form-group label="Check Out Date Between">
                            <v-date-picker v-model="datatable.queryParams.filter.check_out_date"
                                           is-range
                                           :locale="'en'"
                                           :model-config="{type: 'string', mask: 'MM/DD/YYYY'}"
                            >
                                <template v-slot="{ inputValue, inputEvents }">
                                    <div class="border rounded-sm p-1 p-md-3 d-flex align-items-center">
                                        <div class="flex-grow-1">
                                            <b-form-group class="m-0 mr-1">
                                                <input :value="inputValue.start"
                                                       v-on="inputEvents.start"
                                                       :placeholder="$t('start_date')"
                                                       class="form-control"
                                                />
                                            </b-form-group>
                                        </div>
                                        <div class="flex-grow-1">
                                            <b-form-group class="m-0 ml-1">
                                                <input :value="inputValue.end"
                                                       v-on="inputEvents.end"
                                                       :placeholder="$t('end_date')"
                                                       class="form-control"
                                                />
                                            </b-form-group>
                                        </div>
                                    </div>
                                </template>
                            </v-date-picker>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6">
                        <b-form-group :label="$t('status')">
                            <parameter-selectbox
                                :code="'housing_reservation_statuses'"
                                v-model="datatable.queryParams.filter.status"
                            ></parameter-selectbox>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6" class="mb-2 mt-2">
                            <b-form-checkbox
                                v-model="active_reservation_status"
                            >
                                Active Reservations
                            </b-form-checkbox>
                    </b-col>
                    <b-col cols="12" md="6" class="mb-2 mt-2">
                        <b-form-group :label="$t('check_in_status')">
                        <YesNoSelectbox class="w-100" v-model="checkInStatus" />
                        </b-form-group>
                    </b-col>

                </b-row>
            </datatable-filter>
            <datatable :isLoading.sync="datatable.isLoading"
                       :columns="datatable.columns"
                       :rows="datatable.rows"
                       :total="datatable.total"
                       :queryParams="datatable.queryParams"
                       @on-page-change="onPageChange"
                       @on-sort-change="onSortChange"
                       @on-per-page-change="onPerPageChange"
                       v-show="datatable.showTable"
            />
            <CommonModal ref="successModal" size="xl" :onHideOnlyX="true" @bHideModalHeaderClose="formClear">
                <template v-slot:CommonModalTitle>
                    {{ $t('reservation_form_detail').toUpper() }}
                </template>
                <template v-slot:CommonModalContent>
                    <show-form
                        v-if="formProcess == 'reservationModal'"
                        :reservation-data="selectedReservation"
                        :filters="datatable.queryParams.filter"
                        @successUpdate="successfully"
                    />
                </template>
            </CommonModal>
            <CommonModal ref="photoModal" size="md" :onHideOnlyX="true" @bHideModalHeaderClose="closeModal">
                <template v-slot:CommonModalContent>
                    <div id="showCard">
                        <div>
                            <img v-if="asPrint" :src="cardPhotoF" style="width: 100%" />
                            <img v-if="asPrint" :src="cardPhotoB" style="width: 100%" />
                        </div>
                        <div class="d-flex justify-content-center mt-5">
                            <b-button variant="outline-primary" class="mr-2" @click="printCard(studentId,'front')">
                                {{ $t("download_front") }}</b-button>
                            <b-button variant="outline-primary" @click="printCard(studentId,'back')"> {{ $t("download_back") }}</b-button>
                        </div>

                    </div>
                </template>
            </CommonModal>
            <div id="printCard" v-show="false">
                <img v-if="asPrint" :src="cardPhotoP" style="width: 100%" />
            </div>
            <CommonModal ref="createHousingMisconductsFormModal" :onHideOnlyX="true" @bHideModalHeaderClose="formClear">
                <template v-slot:CommonModalTitle>
                    {{ $t('new').toUpper() }}
                </template>
                <template v-slot:CommonModalContent>
                    <create-form @createFormSuccess="hideHousingMisconducts" :reservationId=reservationId v-if="formProcess ==='housing_misconducts'"/>
                </template>
            </CommonModal>
            <CommonModal ref="requestFormModal" size="xl" :onHideOnlyX="true" @bHideModalHeaderClose="formClear">
                <template v-slot:CommonModalTitle>
                    {{ $t('request_form').toUpper() }}
                </template>
                <template v-slot:CommonModalContent>
                    <request-form
                        v-if="formProcess === 'request'"
                        :formId="formId"
                        :reservationData="selectedReservation"
                        :isManual="true"
                        @requestFormSuccess="requestFormSuccess"
                    />
                </template>
            </CommonModal>
        </app-layout>
    </div>
</template>
<script>
// Component
import Datatable from '@/components/datatable/Datatable'
import DatatableFilter from '@/components/datatable/DatatableFilter'
import CommonModal from '@/components/elements/CommonModal'

// Services
import HousingReservationsService from '@/services/HousingReservationsService'

// Pages
import ShowForm from '@/modules/housingReservations/pages/ShowForm'
import RequestForm from '@/modules/myReservationList/pages/RequestForm.vue'


// Other
import qs from 'qs'
import BuildingSelectbox from "@/components/interactive-fields/BuildingSelectbox.vue";
import HouseRoomSelectbox from "@/components/interactive-fields/HouseRoomSelectbox.vue";
import HouseBuildingSelectbox from "@/components/interactive-fields/HouseBuildingSelectbox.vue";
import HouseBedSelectbox from "@/components/interactive-fields/HouseBedSelectbox.vue";
import toBase64 from "@/helpers/toBase64";
import moment from "moment";
import CreateForm from "@/modules/HousingMisconducts/pages/CreateForm.vue";
import CampusService from "@/services/CampusService";
import RefundRequestService from "@/services/RefundRequestService";
import YesNoSelectbox from "@/components/interactive-fields/YesNoSelectbox.vue";

export default {
    props: {
        rsRefresh: {
            type: Boolean,
            default: false
        }
    },
    components: {
        YesNoSelectbox,
        CreateForm,
        HouseBedSelectbox,
        HouseBuildingSelectbox,
        HouseRoomSelectbox,
        BuildingSelectbox,
        Datatable,
        DatatableFilter,
        CommonModal,
        ShowForm,
        RequestForm
    },
    metaInfo() {
        return {
            title: this.$t('housing_reservations')
        }
    },
    data() {
        return {
            checkInStatus: null,
            active_reservation_status: false,
            asPrint: null,
            studentId: null,
            cardPhotoF: null,
            cardPhotoB: null,
            cardPhotoP: null,
            checkInDateFilter: null,
            checkOutDateFilter: null,
            datatable: {
                isLoading: false,
                columns: [
                    {
                        label: '',
                        field: 'buttons',
                        html: true,
                        sortable: false,
                        tdClass: 'p-0 text-center w-40 align-middle',
                        buttons: [
                            {
                                text: this.$t('detail'),
                                class: 'ri-calendar-check-line',
                                hidden: false,
                                permissions: "housingreservation_show",
                                callback: (row) => {
                                    this.updateFormShow(row);
                                }
                            },
                            {
                                text: this.$t('payment_info'),
                                class: 'ri-money-dollar-circle-line',
                                permission: 'customer_tenantpayments',
                                callback: (row) => {
                                    if(row.number){
                                        window.open('/customers/payments/tenant/' + row.number,'_blank');
                                    }
                                }
                            },
                            {
                                text: this.$t("create_id_cart"),
                                class: 'ri-image-add-line align-middle top-minus-1 mr-3 text-muted',
                                permission:'studentcard_create',
                                callback: ({ id }) => {
                                    this.studentId=id
                                    this.previewStudentCard(id)
                                }
                            },
                            {

                                text: this.$t("add_misconduct"),
                                class: 'ri-add-line align-middle top-minus-1 mr-3 text-muted',
                                permission:'housingmisconduct_store',
                                callback: ({id}) => {
                                    this.openHousingMisconducts(id)
                                }
                            },
                            {
                                text: this.$t("add_request_form"),
                                class: 'ri-edit-box-line align-middle top-minus-1 mr-3 text-muted',
                                permission: 'housingrequest_manualstore',
                                callback: (row) => {
                                    this.requestFormShow(row)
                                }
                            },
                            {
                                text: this.$t("checked_in"),
                                class: 'ri-calendar-check-fill align-middle top-minus-1 mr-3 text-muted',
                                permission:'housingreservation_checkedin',
                                show:({checked_in})=>{
                                    return checked_in==='No'
                                },
                                callback: ({id}) => {
                                    this.checkIn(id)
                                }
                            }
                        ]
                    },
                    {
                        label: this.$t('name'),
                        field: 'name',
                        sortable: false
                    },
                    {
                        label: this.$t('surname'),
                        field: 'surname',
                        sortable: false
                    },
                    {
                        label: this.$t('building'),
                        field: 'building_name',
                        sortable: false
                    },
                    {
                        label: this.$t('room'),
                        field: 'room_name',
                        sortable: false
                    },
                    {
                        label: this.$t('room_type'),
                        field: 'room_type_name',
                        sortable: false
                    },
                    {
                        label: this.$t('bed'),
                        field: 'bed_name',
                        sortable: false
                    },
                    {
                        label: this.$t('bed_type'),
                        field: 'bed_type_name',
                        sortable: false
                    },
                    {
                        label: this.$t('check_in_date'),
                        field: 'check_in_date',
                        sortable: false
                    },
                    {
                        label: this.$t('check_out_date'),
                        field: 'check_out_date',
                        sortable: false
                    },
                    {
                        label: this.$t('total_days'),
                        field: 'total_days',
                        sortable: false
                    },
                    {
                        label: this.$t('monthly_fee'),
                        field: 'fee',
                        sortable: false,
                        formatFn: (row) => {
                            return this.currencyFormat(row)
                        }
                    },
                    {
                        label: this.$t('total_amount'),
                        field: 'total_amount',
                        sortable: false,
                        formatFn: (row) => {
                            return this.currencyFormat(row)
                        }
                    },
                    {
                        label: this.$t('paid_amount'),
                        field: 'total_paid_amount',
                        sortable: false,
                        formatFn: (row) => {
                            return this.currencyFormat(row)
                        }
                    },
                    {
                        label: this.$t('balance'),
                        field: 'balance',
                        sortable: false,
                        formatFn: (row) => {
                            return this.currencyFormat(row)
                        }
                    },
                    {
                        label: this.$t('type'),
                        field: 'type_text',
                        sortable: false
                    },
                    {
                        label: this.$t('status'),
                        field: 'status_name',
                        sortable: false
                    },
                    {
                        label: this.$t('check_in_status'),
                        field: 'checked_in',
                        formatFn: (row) => {
                            return row === 'Yes' ? '<span class="badge bg-success text-light">'+this.$t('Yes')+'</span>' : '<span class="badge bg-danger text-light">'+this.$t('No')+'</span>'
                        },
                        sortable: false
                    },
                ],
                rows: [],
                total: 0,
                filterStatus: true,
                showTable: false,
                queryParams: {
                    filter: {
                        date:{
                            start:null,
                            end:null,
                            ckecked_in:null,
                        }
                    },
                    sort: 'id',
                    page: 1,
                    limit: 20
                }
            },
            formLoading: false,
            formId: null,
            formProcess: null,
            date: {
                start: null,
                end: null
            },
            selectedReservation: null,
            reservationId: null,
        }
    },
    watch: {
        rsRefresh: {
            handler: function (val) {
                if (val) {
                    this.getRows()
                }
            }
        },
        'active_reservation_status'(newVal) {
            delete this.datatable.queryParams.filter.check_in_date_between
            delete this.datatable.queryParams.filter.check_out_date_between
            delete this.datatable.queryParams.filter.active_reservation_with_date
            if (newVal) {
                if (this.checkInDateFilter?.end!=null && this.checkInDateFilter?.start!=null){
                    this.checkInDateFilter={}
                }
                if (this.checkOutDateFilter?.end!=null && this.checkOutDateFilter?.start!=null){
                    this.checkOutDateFilter={}
                }
                this.datatable.queryParams.filter.active_reservation_with_date=moment().format('MM/DD/YYYY')
            }
            this.getRows()
        },
        'datatable.queryParams.filter.date':{
            handler: function (val) {
                if (val?.end!=null && val?.start!=null){
                    this.active_reservation_status=false
                    delete this.datatable.queryParams.filter.active_reservation_with_date

                }

            }

        }

    },
    methods: {
        closeModal() {
            this.$refs.photoModal.$refs.commonModal.hide();
            this.asPrint = null;
            this.cardPhoto = null
        },
        filter() {
            this.datatable.queryParams.page = 1;
            this.getRows();
        },
        filterClear() {
            this.datatable.queryParams.filter = {
             date:{
                 end:null,
                 start:null,
             },
            }
            this.checkInStatus=null
            this.active_reservation_status=null
            this.getRows()

        },
        onPageChange(params) {
            this.datatable.queryParams.page = params.currentPage;
            this.getRows();
        },
        onPerPageChange(params) {
            this.datatable.queryParams.limit = params.currentPerPage;
            this.datatable.queryParams.page = 1;
            this.getRows();
        },
        onSortChange(params) {
            const sortType = params[0].type == 'desc' ? '-' : '';
            this.datatable.queryParams.sort = sortType + params[0].field;
            this.getRows();
        },
        exportExcel() {
            this.datatable.queryParams.filter.check_in_date_between = null;
            this.datatable.queryParams.filter.check_out_date_between = null;
            if (this.checkInDateFilter?.end!=null && this.checkInDateFilter?.start!=null){
                this.datatable.queryParams.filter.check_in_date_between = this.checkInDateFilter.start+','+this.checkInDateFilter.end
            }
            if (this.checkOutDateFilter?.end!=null && this.checkOutDateFilter?.start!=null){
                this.datatable.queryParams.filter.check_out_date_between = this.checkOutDateFilter.start+','+this.checkOutDateFilter.end
            }
            let config = {
                params: {
                    ...this.datatable.queryParams
                },
                paramsSerializer: (params) => {
                    const cleanParams = {...params};
                    delete cleanParams.filter.date;
                    return qs.stringify(cleanParams, {encode: false});
                }
            }
            config.responseType = 'arraybuffer'
            return HousingReservationsService.exportExcel(config)
                .then((response) => {
                    this._downloadFile(response, 'Housing Reservations.xlsx');
                })
                .catch((e) => {
                    this.showErrors(e);
                })
                .finally(() => {
                        this.datatable.isLoading = false;
                    }
                );
        },
        async previewStudentCard(id) {
            try {
                let dataF = await HousingReservationsService.createCard(id, "front")
                let dataB = await HousingReservationsService.createCard(id, "back")
                this.asPrint = true;
                this.cardPhotoF = toBase64(dataF);
                this.cardPhotoB = toBase64(dataB);
                this.$refs.photoModal.$refs.commonModal.show()
            } catch (err) {
                this.showErrors(err)
            }
        },
        async printCard(id, side) {
            try {
                if (!side) return
                let data = await HousingReservationsService.printCard(id, side);
                this._downloadFile(data,'student_cart_'+side+'.png')
            } catch (err) {
                this.showErrors(err);
            }
        },
        async getRows() {
            this.datatable.showTable = true
            this.datatable.isLoading = true
            this.datatable.queryParams.filter.check_in_date_between = null;
            this.datatable.queryParams.filter.check_out_date_between = null;
            if (this.checkInDateFilter?.end!=null && this.checkInDateFilter?.start!=null){
                this.datatable.queryParams.filter.check_in_date_between = this.checkInDateFilter.start+','+this.checkInDateFilter.end
            }
            if (this.checkOutDateFilter?.end!=null && this.checkOutDateFilter?.start!=null){
                this.datatable.queryParams.filter.check_out_date_between = this.checkOutDateFilter.start+','+this.checkOutDateFilter.end
            }
            if (this.checkInStatus){
                if (this.checkInStatus==='No'){
                    this.datatable.queryParams.filter.checked_in =false;
                }else {
                    this.datatable.queryParams.filter.checked_in =true;
                }
            }
            const config = {
                params: {
                    ...this.datatable.queryParams
                },
                paramsSerializer: (params) => {
                    const cleanParams = {...params};
                    delete cleanParams.filter.date;
                    return qs.stringify(cleanParams, {encode: false});
                }
            }
            return HousingReservationsService.getAll(config)
                .then((response) => {
                    this.datatable.rows = response.data.data;
                    this.datatable.total = response.data.pagination.total;
                })
                .catch((e) => {
                    this.showErrors(e);
                })
                .finally(() => {
                        this.datatable.isLoading = false;
                    }
                );
        },
        formClear() {
            this.formId = null
            this.formProcess = null
        },
        updateFormShow(selectedRow) {
            this.formProcess = 'reservationModal';
            this.selectedReservation = selectedRow;
            this.$refs.successModal.$refs.commonModal.show();
        },
        openHousingMisconducts(reservation_id) {
            this.formProcess = 'housing_misconducts';
            this.reservationId=reservation_id;
            this.$refs.createHousingMisconductsFormModal.$refs.commonModal.show();
        },
        hideHousingMisconducts() {
            this.formProcess = null;
            this.$refs.createHousingMisconductsFormModal.$refs.commonModal.hide();
        },
        requestFormShow(row) {
            this.formId = row.id;
            this.selectedReservation = row;
            this.formProcess = 'request';
            this.$refs.requestFormModal.$refs.commonModal.show();
        },
        requestFormSuccess() {
            this.$refs.requestFormModal.$refs.commonModal.hide();
            this.getRows();
            this.formClear();
        },
        successfully() {
            this.formProcess = null
            this.$refs.successModal.$refs.commonModal.hide();
            this.getRows();
        },
        checkIn(id){
            this.$swal.fire({
                text: this.$t('check_in_message'),
                showCancelButton: true,
                confirmButtonText: this.$t('yes'),
                cancelButtonText: this.$t('no'),
            }).then((result) => {
                if (result.isConfirmed) {
                    HousingReservationsService.checkIn(id, {checked_in:true})
                        .then(response => {
                            this.$toast.success(this.$t('api.' + response.data.message));
                            this.getRows();
                        })
                        .catch(error => {
                            this.showErrors(error);
                        });
                }
            });
        }
    },
}
</script>
